export const financePageEN = {
  "hero": {
    "title": "AI trading assistant",
    "lead": "For crypto and equity markets based on real-time data. Our Software Development Business Unit together with our Finance Business Unit develops and continuously advances the trading assistant [IDD-driven](idd) (Intent-Driven Development) and automated with [Veridion](veridion); our AI staff evaluate prices, volume, volatility, order books, technical indicators, and financial news with emotion analysis in real time."
  },
  "analysis": {
    "title": "Data analysis in conversation",
    "paragraphs": [
      "In the chat, the AI employees of our Finance Business Unit — orchestrated by [Veridion](veridion) — access all collected market data, indicators, and news directly and answer questions in direct dialogue.",
      "It builds data profiles, computes correlations and regressions on columns of your choice, draws seven kinds of charts, checks the accuracy of the forecasts against the actual prices and recalculates a trading decision with other thresholds and another stop-loss. It takes the current news with its sentiment and the upcoming company events into account in its analysis.",
      "It takes figures only from executed tools; the platform discards an answer with a faked tool result before it appears. If a question is ambiguous, it asks once before touching any data, and the activity display next to the answer shows which steps it took."
    ]
  },
  "features": {
    "title": "Functions",
    "items": [
      {
        "title": "Brokerage account and paper trading",
        "text": "Your brokerage account is connected; holdings, orders, balances and documents are then available in the assistant. Without putting real money at stake, you work in a paper trading account at current prices.",
        "facts": "Live trading with TAN approval per financial instrument · order book with open trades, journal and result · daily report by email"
      },
      {
        "title": "Machine-learning forecast",
        "text": "Each financial instrument has its own model. It learns from the price history, chart patterns, statistical indicators and the sentiment of the news; every day, several hundred of these models are retrained on the latest data. Prices come in every one to four minutes depending on the market, and every completed 30-minute candle produces a new forecast, which is stored and compared with the actual price.",
        "facts": "Random forest with 2,000 trees · MACD, RSI, Bollinger Bands, ADX, chart patterns · MAE, RMSE, MAPE, hit rate"
      },
      {
        "title": "News and sentiment",
        "text": "Business and stock market news from many RSS sources is fetched every two minutes. A language model specialised in financial texts rates the sentiment of every item as positive, neutral or negative; the sentiment of the past 15 minutes to 4 hours enters the forecast with decaying weight.",
        "facts": "Language model on our own GPU · calendar of company events"
      },
      {
        "title": "Signals and automated trading",
        "text": "A signal arises when the forecast is above the entry threshold and market structure or chart patterns confirm it. The automation opens the position, holds it as long as the remaining potential is above the hold threshold and closes it at the stop-loss or before the market closes.",
        "facts": "Long positions only, without credit · thresholds, stop-loss and stake adjustable per financial instrument"
      },
      {
        "title": "Backtests",
        "text": "The trade simulation settles a freely described entry and exit against the real market data. The forecast backtest replays the stored forecast history in three variants.",
        "facts": "Trades, win rate, cumulative return, maximum drawdown, profit factor"
      },
      {
        "title": "Workspace and markets",
        "text": "Charts, analysis, news, portfolio, strategy, order book, brokerage, data tables and assistant sit side by side as movable windows. The chart shows price and forecast curve together, with indicators and detected chart patterns.",
        "facts": "DAX 40, MDAX, TecDAX, EURO STOXX 50, Dow Jones, Nasdaq 100, Nikkei 225 · EUR/USD, EUR/GBP · Bitcoin · intervals from 2 minutes to 12 hours"
      },
      {
        "title": "Operation",
        "text": "The application runs on our own platform, and every signed-in person works in a separate, isolated instance. Sign-in requires a second factor, and all AI calls go through one central access point with fixed quotas.",
        "facts": ""
      }
    ]
  },
  "cta": {
    "title": "Access",
    "subtitle": "The trading assistant is available as a subscription on our platform. Write to us and we will be glad to set up your access.",
    "button": "Request access",
    "subject": "Access to the AI trading assistant"
  }
};
